export { default } from './PublisherSettings';
